import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { useT } from "@/lib/i18n";

/**
 * Mobile-only sticky CTA. Shown after the user has scrolled past the hero
 * so it never overlaps the primary login/signup buttons that already live
 * in the fold. Hidden on ≥ sm breakpoint so desktop keeps its calm layout.
 */
export default function MobileStickyCTA({ onStart }) {
  const { t } = useT();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="mobile-sticky-cta"
      className={`sm:hidden fixed inset-x-0 bottom-0 z-40 border-t border-black/10 bg-[#F9F8F6]/95 backdrop-blur px-4 py-3 flex items-center justify-between gap-3 transition-transform duration-300 ${visible ? "translate-y-0" : "translate-y-full"}`}
    >
      <div className="min-w-0">
        <p className="font-serif text-sm leading-tight text-neutral-900 truncate">{t("mobStickyTitle")}</p>
        <p className="font-mono text-[0.55rem] uppercase tracking-[0.15em] text-neutral-500">{t("mobStickyHint")}</p>
      </div>
      <button
        data-testid="mobile-sticky-cta-btn"
        type="button"
        onClick={onStart}
        className="shrink-0 font-mono text-[0.65rem] uppercase tracking-[0.15em] bg-neutral-900 text-[#F9F8F6] px-3 py-2 inline-flex items-center gap-1.5"
      >
        {t("mobStickyCta")} <ArrowRight size={12} strokeWidth={1.75} />
      </button>
    </div>
  );
}
